import { StyledButtonPrimary } from "./button-primary.styles";

const ButtonPrimary = () => {
  return (
    <StyledButtonPrimary variant="contained">
      Request beta access
    </StyledButtonPrimary>
  );
};

export default ButtonPrimary;
